import { createTheme } from "@mui/material/styles";
import { localeLineBreakComponents } from "@wedding/shared";

const baseTheme = createTheme();

export const theme = createTheme({
  palette: {
    primary: {
      main: "#8B6F5E",
      light: "#B89B8A",
      dark: "#5E4635",
    },
    secondary: {
      main: "#C9A87C",
      light: "#E5D4B7",
      dark: "#9E7F54",
    },
    background: {
      default: "#FDF8F4",
      paper: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 700,
      fontSize: "2rem",
      [baseTheme.breakpoints.up("sm")]: { fontSize: "2.5rem" },
      [baseTheme.breakpoints.up("md")]: { fontSize: "3.75rem" },
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.75rem",
      [baseTheme.breakpoints.up("sm")]: { fontSize: "2.125rem" },
      [baseTheme.breakpoints.up("md")]: { fontSize: "2.5rem" },
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.5rem",
      [baseTheme.breakpoints.up("sm")]: { fontSize: "1.75rem" },
      [baseTheme.breakpoints.up("md")]: { fontSize: "2rem" },
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.25rem",
      [baseTheme.breakpoints.up("sm")]: { fontSize: "1.5rem" },
      [baseTheme.breakpoints.up("md")]: { fontSize: "1.75rem" },
    },
    h5: { fontFamily: '"Playfair Display", serif', fontWeight: 600 },
    h6: { fontFamily: '"Playfair Display", serif', fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    ...localeLineBreakComponents,
    MuiButton: {
      styleOverrides: {
        root: {
          ...localeLineBreakComponents.MuiButton.styleOverrides.root,
          textTransform: "none",
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        },
      },
    },
  },
});
